import { useLazyQuery } from '@apollo/client';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { FORM_PAGES } from '../../../components/Form/types';
import FormChoice from '../../../components/FormChoice/FormChoice';
import { FORM_CHOICE_COMPONENT_TYPES, FORM_CHOICE_TYPES } from '../../../components/FormChoice/types';
import { vars } from '../../../reactive';
import { setFormPage } from '../../../reactive/actions';
import { GetAllPets } from '../../../utils/queries';

const FormAddPet = () => {
  const { t } = useTranslation();
  const currentBranch = vars.currentBranch();
  const petTypes = currentBranch?.BranchTargeting?.pet_type;
  const isMoreThanOnePetType = petTypes.length > 1;
  const newPet = vars.newPet();
  const { register, control, reset, setValue } = useForm();
  const type = FORM_CHOICE_TYPES.ADD_PET;
  const { registerAs } = FORM_CHOICE_COMPONENT_TYPES[type];
  const title = t(FORM_CHOICE_COMPONENT_TYPES[type]?.title, { petName: newPet.name });
  const data = useWatch({ name: `choice_${registerAs}`, control });

  const [getAllPets, { loading: getPetsLoading, data: { getProfile: userProfile } = {} }] = useLazyQuery(GetAllPets);

  useEffect(() => {
    if (data) {
      if (data === 'true') {
        if (isMoreThanOnePetType) {
          setFormPage(FORM_PAGES.CREATE_PET_TYPE, 'fade-out');
        } else {
          vars.newPet({ ...newPet, type: petTypes[0] });
          setFormPage(FORM_PAGES.CREATE_PET_CREATE_PET);
        }
      } else {
        getAllPets();
      }
    }
  }, [data]);

  useEffect(() => {
    if (userProfile) {
      const allPets = [...userProfile.Pets, ...userProfile.ChappedPets];
      vars.allPets(allPets);
      setFormPage(FORM_PAGES.BOOKING_SELECT_PETS);
    }
  }, [userProfile]);

  return (
    <FormChoice
      type={type}
      formOptions={{ register, reset, setValue }}
      title={title}
      previousPage={{
        page: FORM_PAGES.BOOKING_SELECT_PETS,
        animation: 'fade'
      }}
    />
  );
};

export default FormAddPet;
